export const fileSizeFormat = (size: number): string => {
  if (size <= 0) {
    return '0 B';
  }

  const units = ['B', 'kB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(size) / Math.log(1000));
  const formattedSize = (size / 1000 ** i).toFixed(2);

  return `${formattedSize} ${units[i]}`;
};
